import { render, staticRenderFns } from "./FigureStat.vue?vue&type=template&id=ac5f78f6&scoped=true&lang=pug&"
import script from "./FigureStat.vue?vue&type=script&lang=js&"
export * from "./FigureStat.vue?vue&type=script&lang=js&"
import style0 from "./FigureStat.vue?vue&type=style&index=0&id=ac5f78f6&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5f78f6",
  null
  
)

export default component.exports